module.exports = __webpack_public_path__ + "img/1024x500.6345eb0f.png";